module.exports = __webpack_public_path__ + "static/media/pw6.75c0c026.png";